// src/hooks/useProtectedStep.ts
import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import useNavigateWithLang from "./useNavigateWithLang";
import { getLovForField, guestsReadyToProceed } from "../utils/guestUtils";
import { getTenantConfig } from "../config/tenant";

const useProtectedStep = () => {
    const { state } = useContext(AppContext) ?? {};
    const location = useLocation();
    const { navigateWithLang } = useNavigateWithLang();

    useEffect(() => {
        const path = location.pathname;
        const needsGuestsComplete =
            path.includes("/payment") || path.includes("/check-in-complete");

        if (!needsGuestsComplete) return;

        const guests = state?.guests ?? [];
        // ✅ Don’t decide until we actually have guests in state
        if (guests.length === 0) return;

        // Per-field LOV resolution: each field reads from its configured source on the chain
        // (defaults preserve pre-V14 hard-wiring). Without this, a route guard couldn't tell
        // the difference between an unfilled country and one filled from a non-default LOV.
        const lovMaps = { nationalities: state?.nationalities, countries: state?.countries };
        const tenantLovSources = getTenantConfig()?.lovSources;
        const mandatoryDataLovs = {
            nationality: getLovForField("nationality", tenantLovSources, lovMaps),
            birthCountry: getLovForField("birthCountry", tenantLovSources, lovMaps),
            addressCountry: getLovForField("addressCountry", tenantLovSources, lovMaps),
        };
        const allComplete = guestsReadyToProceed(guests, mandatoryDataLovs);

        if (!allComplete) {
            navigateWithLang("/guest-info");
        }
    }, [location.pathname, state?.guests, state?.nationalities, state?.countries, navigateWithLang]);
};

export default useProtectedStep;
